import axios from "axios";
import config from "../config.json";

const BASE = (process.env.REACT_APP_API_BASE || `${config.service}/api`).replace(/\/$/, "");

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  if (!cfg.headers["Content-Type"]) {
    cfg.headers["Content-Type"] = "application/json";
  }
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Не разлогиниваем автоматически, чтобы увидеть причину 401 в Network
    console.error("API error", {
      url: err?.config?.url,
      method: err?.config?.method,
      status: err?.response?.status,
      data: err?.response?.data,
    });
    return Promise.reject(err);
  }
);

export default api;


